/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1657
 */

var r = require(/* 86 */"./1650/86/index")
var o = require(/* 1260 */"./1684/1260")
r({
  target: "Number",
  stat: true,
  forced: Number.parseFloat != o
}, {
  parseFloat: o
})
